import React from 'react'
import SliderNewsAdvertisement from '../../component/slidercomponent/SliderNewsAdvertisement'

const NewsAdvertisement = () => {
    return (
        <>
            <section className="result-list">
                <div className="container">
                    <div className="row">
                        <div className="col-md-3">
                            <div className="sec-title mb-3" data-aos="fade-up" data-aos-duration={1000}>
                                {/* <span className="title">News Advertisement</span> */}
                                <h2>News Advertisement</h2>
                                <div className="divider">
                                    <span className="fa fa-mortar-board" />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-9">
                            <div className="autoplay">
                                <SliderNewsAdvertisement />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default NewsAdvertisement